import { urls } from "@/modules/app/utils/urls.ts";

export class BrowserTab {
  private newTab: any;

  constructor(route = "about:blank", target = "_blank") {
    // We open the new blank tab as long as we are in the context of the trusted event (user clicked)
    let url: string = route;
    if (route !== "about:blank") {
      url = BrowserTab.createUrl(route);
    }
    this.newTab = window.open(url, target);
  }

  static createUrl(route: string): string {
    // Create the url based on the config and route
    const baseUrl: string =
      location.origin + (urls.basePath === "/" ? "" : urls.basePath.substr(0, urls.basePath.length - 1));
    // is it better to use document.baseURI.replace(/\/$/, "")) + route ?
    return baseUrl + route;
  }

  goTo(route: string) {
    // Upon success we change the location of this new tab dynamically
    this.newTab.location.assign(BrowserTab.createUrl(route));
  }

  goToAbsoluteURL(url: string) {
    // Upon success we change the location of this new tab dynamically
    this.newTab.location.assign(url);
  }
}
